import type { IconData } from '@stacksjs/iconify-core'

export const userFaceMaleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 9.952c-3.393 7.667-10.766 13.18-19.5 13.915V24c0 10.77 8.73 19.5 19.5 19.5S43.5 34.77 43.5 24v-.133C34.766 23.131 27.393 17.62 24 9.952m19.058.296A23.4 23.4 0 0 1 47.5 24c0 12.979-10.521 23.5-23.5 23.5S.5 36.979.5 24c0-6.22 2.417-11.877 6.363-16.08A23.43 23.43 0 0 1 23.895.5h.21c7.61.033 14.366 3.684 18.638 9.321q.159.212.315.427M17.854 32.676a2 2 0 0 0-3.344 2.195c2.156 3.285 5.914 4.811 9.49 4.811s7.334-1.526 9.49-4.811a2 2 0 1 0-3.344-2.195c-1.264 1.927-3.614 3.006-6.146 3.006s-4.882-1.08-6.146-3.006m-.695-11.653a2 2 0 0 1 2 2v1.955a2 2 0 0 1-4 0v-1.955a2 2 0 0 1 2-2m11.682 2a2 2 0 0 1 4 0v1.955a2 2 0 1 1-4 0z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userFaceMaleRemix
